import type { Dependencies, v4 } from '@sap/ux-specification-types';

/**
 * Method updates passed dependency lib in passed manifest.
 *
 * @param manifest - Manifest "sap.ui5" object.
 * @param name - Library name to check.
 * @param [add] - Add or remove library.
 */
export function updateDependencyLib(manifest: v4.SapUi5V4, name: string, add = true): void {
    if (add) {
        if (!manifest.dependencies) {
            manifest.dependencies = {} as Dependencies;
        }
        if (!manifest.dependencies.libs) {
            manifest.dependencies.libs = {};
        }
        if (manifest.dependencies.libs[name] === undefined) {
            manifest.dependencies.libs[name] = {};
        }
    } else if (manifest.dependencies && manifest.dependencies.libs && manifest.dependencies.libs[name] !== undefined) {
        delete manifest.dependencies.libs[name];
    }
}

/**
 * Looks for <...> pattern in the input string; if found, extracts this last part of the string.
 *
 * @param longId - schema ID in its long format
 * @returns the converted ID
 */
export function extractLastIdPart(longId: string): string {
    let lastIdPart = longId;
    if (longId.indexOf('<') > -1) {
        lastIdPart = longId.substring(longId.indexOf('<') + 1, longId.length - 1);
        const navPart = longId.substring(0, longId.lastIndexOf('::')).replace(/::/g, '/');
        if (navPart) {
            lastIdPart = `${navPart}/${lastIdPart}`;
        }
    }
    return lastIdPart;
}
